<template>
  <div class="feedback-container" style="">
    <el-card class="feedback-card">
      <el-form :model="form"  style="display: flex;flex-wrap: wrap;">
            <el-form-item label="创建时间："  style="display: flex;margin-right: 20px;">
              <el-date-picker
                v-model="form.startDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择开始日期">
              </el-date-picker>
              <span style="margin: 0px 10px;">至</span>
              <el-date-picker
                v-model="form.endDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="提交时间："  style="display: flex;margin-right: 20px;">
              <el-date-picker
                v-model="form.commitDateStart"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择提交开始">
              </el-date-picker>
              <span style="margin: 0px 10px;">至</span>
              <el-date-picker
                v-model="form.commitDateEnd"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择提交结束">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="学科名称："  style="display: flex;margin-right: 20px;">
              <el-select v-model="form.subject" placeholder="请选择学科" filterable clearable>
                <el-option
                  v-for="item in subjects"
                  :key="item.categoryId"
                  :label="item.categoryName"
                  :value="item.categoryId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上课老师：" style="display: flex;margin-right: 20px;">
              <el-select v-model="form.teacher" placeholder="请选择老师" filterable clearable>
                <el-option
                  v-for="item in teachers"
                  :key="item.teacherId"
                  :label="item.teacherName"
                  :value="item.teacherId">
                </el-option>
              </el-select>
            </el-form-item>
        <el-row :gutter="20" style="text-align: right; margin-top: 20px;width: 100%;">
          <el-button class="btns" size="small" type="primary" @click="search">搜索</el-button>
          <el-button class="btns" size="small" type="primary" @click="clear">清除</el-button>
          <!-- <el-button class="btns" size="small" type="primary" @click="add">添加</el-button> -->
          <el-button class="btns" size="small" type="primary" @click="exportData">导出</el-button>
        </el-row>
      </el-form>
      <el-table  :data="tableData"  :empty-text="noDataText" height="700"  style="width: 100%; margin-top: 20px; " :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}">
        <el-table-column prop="studentName" label="学生" ></el-table-column>
        <el-table-column prop="teacherName" label="老师" ></el-table-column>
        <el-table-column prop="categoryName" label="学科" ></el-table-column>
        <el-table-column prop="gradeNames" label="年级" ></el-table-column>
        <el-table-column prop="courseDate" label="上课日期" ></el-table-column>
        <el-table-column prop="classDate" label="上课时间" ></el-table-column>
        <el-table-column prop="accomplish" label="教师反馈情况" width="200">
          <template v-slot="scope">
            <span v-if="scope.row.accomplish === 1">未反馈</span>
            <span v-if="scope.row.accomplish === 2">已反馈</span>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="课后反馈" ></el-table-column>
        <el-table-column prop="commitDate" label="提交时间" ></el-table-column>
        <!-- <el-table-column prop="taskCondition" label="作业完成情况" ></el-table-column>
        <el-table-column prop="classCondition" label="上课吸收情况" ></el-table-column>
        <el-table-column prop="campusExpression" label="校园表现情况" ></el-table-column>
        <el-table-column prop="examCondition" label="近期考试情况" ></el-table-column>
        <el-table-column prop="spiritFace" label="精神面貌情况" ></el-table-column>
        <el-table-column prop="createTime" label="创建时间" ></el-table-column>
        <el-table-column prop="commitDate" label="提交时间" ></el-table-column>
        <el-table-column prop="createName" label="创建人" ></el-table-column> -->
        <el-table-column label="操作" width="180">
          <template v-slot="scope">
            <el-button @click="handleView(scope.$index, scope.row)" type="text"  size="small">查看</el-button>
            <el-button @click="handleEdit(scope.$index, scope.row)" type="text"  size="small">编辑</el-button>
            <!-- <el-button @click="handleDelete(scope.$index, scope.row)" type="text"  size="small">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container" style="text-align: center; margin-top: 20px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>

    </el-card>



    <el-dialog :visible="showpopLong" center :title="showpopLongtitle" modal-append-to-body append-to-body :close-no-click-modal="false" :before-close="showpopLongCloseDialog" width="60%" >
      <!-- <isshowpopLong :studentData="studentData" :dataRow="dataRow" v-if="showpopLong" @handlecancel="handlecancel" :showpopLongtitle="showpopLongtitle"></isshowpopLong> -->


      <div action="">
        <div class="form-item">
          <label for="">学生：</label>
          <el-input style="margin: 15px 0px;" type="text" v-model="dataRow.studentName" disabled></el-input>
        </div>
        <div class="form-item">
          <label for="">老师：</label>
          <el-input style="margin: 15px 0px;" type="text" v-model="dataRow.teacherName" disabled></el-input>
        </div>
        <div class="form-item">
          <label for="">学科：</label>
          <el-input style="margin: 15px 0px;" type="text" v-model="dataRow.categoryName" disabled></el-input>
        </div>
       <div class="form-item">
          <label for="">年级：</label>
          <el-input style="margin: 15px 0px;" type="text" v-model="dataRow.gradeNames" disabled></el-input>
        </div>
        <div class="form-item">
          <label for="">上课日期：</label>
          <el-input style="margin: 15px 0px;" type="text" v-model="dataRow.courseDate" disabled></el-input>
        </div>
        <div class="form-item">
          <label for="">上课时间：</label>
          <el-input style="margin: 15px 0px;"  type="text" v-model="dataRow.classDate" disabled></el-input>
        </div>
        <div class="form-item">
          <label for="">教师反馈情况：</label>
          <el-select v-model="dataRow.accomplish" style="width: 100%;margin: 15px 0px;"  filterable clearable disabled>
            <el-option
              v-for="item in teachersssssss"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="form-item">
          <label for="">课后反馈：</label>
          <el-input style="margin: 15px 0px;" type="textarea" v-model="dataRow.content" :disabled="showpopLongtitle === '查看' ? true : false" :autosize="{ minRows: 6, maxRows: 6}"></el-input>
        </div>
        <div class="form-item">
          <label for="">提交时间：</label>
          <el-input style="margin: 15px 0px;" type="text" v-model="dataRow.commitDate" disabled></el-input>
        </div>
      </div>


      <div style="text-align: center; margin-top: 20px;">
        <el-button type="primary"  @click="handlecancels">确定</el-button>
        <el-button type="primary" @click="showpopLongCloseDialog">取消</el-button>
      </div>



    </el-dialog>


  </div>
</template>

<script>
import isshowpopLong from "./showpopLong.vue";
import axios from "axios";
import apiBaseUrl from "../../../../config/api";
export default {
  components: {
    isshowpopLong,
  },
  props: {
    studentData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      currentPage: 1,
      total:0,
      pageSize: 10,
      tableHeight: 400, // 表格高度
      noDataText: '暂无数据', // 无数据时显示的文本
      form: {
        startDate: '',
        endDate: '',
        subject: '',
        teacher: '',
        commitDateStart: '',
        commitDateEnd: '',

      },
      subjects: [
        // { value: 'math', label: '数学' },
        // { value: 'english', label: '英语' },
        // { value: 'science', label: '科学' }
      ],
      teachers: [
        // { value: 'teacher1', label: '张老师' },
        // { value: 'teacher2', label: '李老师' },
        // { value: 'teacher3', label: '王老师' }
      ],

      teachersssssss: [
        { value: 1, label: '未反馈' },
        { value: 2, label: '已反馈' },
      ],

      tableData: [
        // 示例数据
        // {
        //   student: '张三',
        //   teacher: '张老师',
        //   subject: '数学',
        //   grade: '三年级',
        //   homeworkCompletion: '已完成',
        //   classAbsorption: '良好',
        //   campusPerformance: '优秀',
        //   recentExam: '95分',
        //   spiritualAppearance: '积极',
        //   createTime: '2023-10-01',
        //   creator: '管理员'
        // },
        // 更多数据...
      ],

      showpopLong: false,
      showpopLongtitle:'',

      dataRow:{},

    };
  },
  computed: {
    paginatedTableData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.tableData.slice(start, end);
    }
  },

  mounted(){
    this.handlestudentDiagnosefindInfo()
    this.getAllAxios()
  },


  methods: {

    handlecancels(){

      if(this.dataRow.id && this.dataRow.content){
          let data = {
            id: this.dataRow.id ? this.dataRow.id : '',
            content: this.dataRow.content ? this.dataRow.content : '',
          }
          axios.post(`${apiBaseUrl}/feedbackLearning/update`, data, { headers: { authorization: sessionStorage.getItem("tokenInfo"),},}).then((res) => {
              if (res.data.code === 200){
                  this.showpopLongtitle = ''
                  this.showpopLong = false
                  this.dataRow = {}
                  this.handlestudentDiagnosefindInfo()
                  this.$message({ type: 'success', message: res.data.message ? res.data.message : res.data.meg })
              }else{
                this.$message({ type: 'error', message: res.data.message ? res.data.message : res.data.meg })
              }
            }).catch((error) => {
              this.$message({ type: 'error', message: error })
          })
      }else{
        this.$message({ type: 'warning', message: '请输入课后反馈~' })
      }

    },

    getAllAxios() {
      axios.get(`${apiBaseUrl}/studentFeedback/getCategoryList/${this.studentData.id}`, { headers: { authorization: sessionStorage.getItem("tokenInfo"),  },}).then((res) => {
         this.subjects = res.data.data
      }).catch((error) => {
         this.$message({ type: 'error', message: error })
      })
      axios.get(`${apiBaseUrl}/studentFeedback/getTeacherList/${this.studentData.id}`, { headers: { authorization: sessionStorage.getItem("tokenInfo"),  },}).then((res) => {
         this.teachers = res.data.data
      }).catch((error) => {
         this.$message({ type: 'error', message: error })
      })
    },

    handlestudentDiagnosefindInfo(){
      let data = {
        pageNum: this.currentPage ? this.currentPage : 1,
        pageSize: this.pageSize ? this.pageSize : 10,
        categoryId: this.form.subject ? this.form.subject : null,
        teacherId: this.form.teacher ? this.form.teacher : null,
        createTimeStart: this.form.startDate ? this.form.startDate + ' 00:00:00' : null,
        createTimeEnd: this.form.endDate ? this.form.endDate + ' 23:59:59': null,
        studentId: this.studentData.id ? this.studentData.id : '',
        commitDateStart: this.form.commitDateStart ? this.form.commitDateStart : null,
        commitDateEnd: this.form.commitDateEnd ? this.form.commitDateEnd : null,

      }
      axios.post(`${apiBaseUrl}/feedbackLearning/page`, data, { headers: { authorization: sessionStorage.getItem("tokenInfo"),},}).then((res) => {
          if (res.data.code === 200){
              let data = res.data.data

              if(data.records.length > 0){
                 this.tableData = data.records
              }else{
                this.tableData = []
              }

              this.currentPage = data.current
              this.pageSize = data.size
              this.total = data.total

              this.$message({ type: 'success', message: '获取数据成功!' })
          }else{
            this.$message({ type: 'error', message: '获取数据失败' })
          }

        }).catch((error) => {
          this.tableData = []
          this.$message({ type: 'error', message: error })
      })
    },

    handlecancel() {
      this.showpopLong = false;
      this.handlestudentDiagnosefindInfo()
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.handlestudentDiagnosefindInfo()
    },
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
      this.handlestudentDiagnosefindInfo()
    },
    search() {
      this.handlestudentDiagnosefindInfo()
    },
    clear() {
      // 清除逻辑
      this.form = {
        startDate: '',
        endDate: '',
        subject: '',
        teacher: '',
        commitDateStart: '',
        commitDateEnd: '',

      }

      this.currentPage = 1
      this.pageSize = 10

      this.handlestudentDiagnosefindInfo()
    },

    showpopLongCloseDialog() {
      this.handlestudentDiagnosefindInfo()
      this.showpopLongtitle = ''
      // this.dataRow = {}
      this.showpopLong = false
    },
    add() {
      // 添加逻辑
      this.showpopLongtitle = '添加'
      this.dataRow = {}
      this.showpopLong = true
      console.log('添加');
    },
    exportData() {
      let data = {
       pageNum: this.currentPage ? this.currentPage : 1,
        pageSize: this.pageSize ? this.pageSize : 10,
        categoryId: this.form.subject ? this.form.subject : null,
        teacherId: this.form.teacher ? this.form.teacher : null,
        createTimeStart: this.form.startDate ? this.form.startDate + ' 00:00:00' : null,
        createTimeEnd: this.form.endDate ? this.form.endDate + ' 23:59:59': null,
        studentId: this.studentData.id ? this.studentData.id : '',
        commitDateStart: this.form.commitDateStart ? this.form.commitDateStart : null,
        commitDateEnd: this.form.commitDateEnd ? this.form.commitDateEnd : null,
      }
      axios.post(`${apiBaseUrl}/feedbackLearning/excelTeacherFeeback`, data, { responseType: "blob", headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then((res) => {
          const blob = new Blob([res.data], { type: "application/vnd.ms-excel",})
          const downloadLink = document.createElement("a")
          downloadLink.href = URL.createObjectURL(blob)
          downloadLink.download = "学习力反馈.xlsx"
          downloadLink.click()
      })

    },
    handleView(index, row) {
      // 查看逻辑
      this.showpopLongtitle = '查看'
      this.dataRow = row
      this.showpopLong = true
      console.log(`查看: row`);
    },
    handleEdit(index, row) {
      this.showpopLongtitle = '编辑'
      this.dataRow = row
      this.showpopLong = true
      // 编辑逻辑
      console.log(row);
    },
    handleDelete(index, row) {
        this.$confirm('再次确认, 是否真的要删除?', '确认', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'error'}).then(() => {
          axios.post(`${apiBaseUrl}/studentFeedback/delete/${row.id}`, {}, { headers: { authorization: sessionStorage.getItem("tokenInfo"),},}).then((res) => {
              if (res.data.code === 200){
                 this.$message({ type: 'success',  message: '删除成功!' });
              }else{
                 this.$message({ type: 'error', message: '删除失败' })
              }
            }).catch((error) => {
              this.$message({ type: 'error', message: error })
          })
        }).catch(() => {
          this.$message({ type: 'info',  message: '已取消删除'  });
        });

    }
  }
};
</script>

<style scoped>
.feedback-container {
  padding: 20px;
}
.feedback-card {
  margin-bottom: 20px;
}
.clearfix::after {
  content: '';
  display: block;
  clear: both;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
.btns {
  background-color: #428bca;
  border-color: #428bca;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/subassembly/learningFeedback.vue